import React, {Component} from 'react';
import {
    AJAX,
    showPreloader,
    hidePreloader,
    close_popup, addStepLog, setUrlSinglePageApp
} from "../functions";
import {Redirect} from "react-router-dom";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import ProfileFields from "../common/ProfileFields";
import AuthCodePopup from "../popups/AuthCodePopup";
import {withRouter} from "react-router";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";

class SavingProfileFromRCMPage extends Component {
    constructor(props) {
        super(props);
        this.state = {answer: null, client_data:{}, errorInputs: {}, showPinCodePopupIfAlreadyAuth:false};
        if (this.props.rcm_client_data)
            this.state.client_data = this.props.rcm_client_data;
        this.props.client_data_fields.forEach(el => {if(!this.state.client_data[el]) this.state.client_data[el] = ''});

        this.handleUserInput = this.handleUserInput.bind(this);
        this.onClickAnswer = this.onClickAnswer.bind(this);
        this.saveProfile = this.saveProfile.bind(this);

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    onClickAnswer(answ) {
        switch (answ) {
            case 'yes':
                addStepLog('Press button YES on Your data saving Page');
                this.saveProfile();
                break;
            case 'no':
                this.setState({answer: answ/*, redirect: true*/});
                showPreloader();
                addStepLog('Press button NO on Your data saving Page', false, '/welcome/');
//                window.location.href = bm_base_path + '/welcome/';
                return false;
        }
    }

    saveProfile() {
        let t = this;
        let params = {...this.state.client_data};
        params.action = 'api/booking/save_profile';

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: function () {
                showPreloader();
            },
            func_callback: function (resp) {
                if (resp.success === 1 && Object.keys(resp.data).length && resp.data.profile_data) {
                    t.setState({client_data: resp.data.profile_data, already_auth:true});
                    window.gClientData = resp.data.profile_data;
                    t.setState({answer: 'yes'/*, redirect: true*/});
                    window.location.href = bm_base_path + '/welcome/';
                } else if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                    showPopupWithGoBack(resp.errors.main);
                }

                if (resp.errors !== undefined && resp.errors.form !== undefined) {
                    hidePreloader();
                    t.setState({errorInputs: resp.errors.form});
                }

                if (resp.errors !== undefined && resp.errors.email_exists) {
                    hidePreloader();
                    t.setState({email_exists: true});
                    t.setState({showPinCodePopupIfAlreadyAuth: true});
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    handleUserInput(e) {
        let name = e.target.name;
        let value = e.target.value;

        if (this.props.client_data_fields.indexOf(name) !== -1) {
            let cd = this.state.client_data;
            cd[name] = value;
            this.setState({client_data: cd});
        }
    }

    render() {
        if (this.state.redirect)
            return  <Redirect push to='/welcome/' />;

        return (<>
            <RedirectOnlyHome />
            <div className={'value-space'}>
                <div className="row">
                    <div className="offset-2 col-8">
                        <h1 className="my-4">Would you like to save your data?</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8 text-center">
                        <div className="mb-3">
                            <button type="button"
                                    className={'base-input white-green mb-4' + (this.state.answer === 'yes' ? ' selected' : '')}
                                    onClick={()=>this.onClickAnswer('yes')}>
                                YES
                            </button>
                            <button type="button"
                                    className={'base-input white-red mb-4' + (this.state.answer === 'no' ? ' selected' : '')}
                                    onClick={()=>this.onClickAnswer('no')}>
                                NO
                            </button>
                        </div>
                        <ProfileFields client_data={this.state.client_data}
                                       errors={this.state.errorInputs}
                                       handleUserInput={this.handleUserInput}
                        />
                    </div>
                </div>
                <AuthCodePopup showPopup={this.state.showPinCodePopupIfAlreadyAuth}
                               email={this.state.client_data.email}
                               handleClosePopup={()=>this.setState({showPinCodePopupIfAlreadyAuth: false})}
                               handleSuccessfulRequest={this.saveProfile}
                               already_auth
                />
            </div>
        </>);
    }
}

const SavingProfileFromRCMPageR = withRouter(SavingProfileFromRCMPage);
export default SavingProfileFromRCMPageR;
